<ng-container *ngIf="summaryData && summaryData.pdfIds && summaryData.pdfIds.length > 0">
  <div>
    <div class="d-flex flex-row gap-2">
      <img class="file-icon" src="/assets/icons/document-duplicate.svg" alt="File icon" />
      <div class="d-flex flex-column">
        <span class="file-label">{{ 'work_order' | translate }}</span>
        <span class="file-count">
          <span *ngIf="summaryData.pdfIds.length === 1">{{ summaryData.pdfIds.length }} {{ 'attached_file' | translate
            }}</span>
          <span *ngIf="summaryData.pdfIds.length > 1">{{ summaryData.pdfIds.length }} {{ 'attached_files' | translate
            }}</span>
        </span>
      </div>
    </div>
    <hr class="section-divider" />
  </div>
</ng-container>